var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.76884 5.15625C10.5072 5.15625 13.5374 8.20768 13.5374 11.9715C13.5374 15.7354 10.5069 18.7866 6.76884 18.7866C3.03073 18.7866 0 15.7354 0 11.9715C0 8.20768 3.0305 5.15625 6.76884 5.15625ZM17.5782 5.55547C19.4474 5.55547 20.9626 8.42775 20.9626 11.9715H20.9628C20.9628 15.5144 19.4476 18.3876 17.5784 18.3876C15.7092 18.3876 14.194 15.5144 14.194 11.9715C14.194 8.42867 15.709 5.55547 17.5782 5.55547ZM22.8097 6.22375C23.4669 6.22375 24 8.79708 24 11.9715C24 15.1451 23.4672 17.7193 22.8097 17.7193C22.1522 17.7193 21.6196 15.1458 21.6196 11.9715C21.6196 8.79731 22.1524 6.22375 22.8097 6.22375Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.3f16f9b268ba3364a8d695ef251573f1.svg";
export { ForwardRef as ReactComponent };